import gsap from "@traina/gsap";
import {ScrollTrigger} from "@traina/gsap/ScrollTrigger";
import {ScrollSmoother} from "@traina/gsap/ScrollSmoother";
import {DrawSVGPlugin} from "@traina/gsap/DrawSVGPlugin";
import {SplitText} from "@traina/gsap/SplitText";
import {Flip} from "@traina/gsap/Flip";


gsap.config({
    nullTargetWarn:false
})

let smoother;

export const setSmoother = (val) => smoother = val;

export function forceScrollSmootherUpdate(){
    if(smoother){
        ScrollTrigger.refresh();
    }
}

export function addScrollSmootherEffects(target, config){
    if(smoother){
        smoother.effects(target, config);
    }
}

export function scrollToTop() {
    if( smoother ) {
        ScrollSmoother.get().scrollTop(0);
        window.scrollTop = 0;
        ScrollTrigger.refresh();

    } else {
        window.scrollTo(0,0);
    }
}

let scrollPosition = smoother ? smoother.scrollTop() : window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
if(!smoother){
    window.addEventListener('scroll', ()=>{
        scrollPosition = smoother ? smoother.scrollTop() : window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
    });
    window.addEventListener('resize', () => {
        scrollPosition = smoother ? smoother.scrollTop() : window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
    });
}

export {gsap,ScrollTrigger,ScrollSmoother, DrawSVGPlugin, SplitText, smoother, Flip, scrollPosition};